import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Auth0Service } from '../../authentication/auth0/auth0.service';
import { LoaderService } from '../../services/loader/loader.service';
import { Router } from '@angular/router';
/**
 * This is a common service to call backend API, it contains 4 functions get, post, put, and delete.
 */
@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient,
    private auth0: Auth0Service,
    private router: Router,
    private loader: LoaderService) { }

  private header = new HttpHeaders({ "content-type": "application/json" , "Accept": "application/json" })
  /**
   * This function is used to call the post API, it takes two parameters
   * @param endpoint 
   * @param data 
   */
  post(endpoint, data) {
    const url = getUrl(endpoint);
    return this.http.post(url, data, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  /**
   * This function is used to call the get API, it takes a single parameter
   * @param endpoint 
   */
  get(endpoint) {
    const url = getUrl(endpoint);
    return this.http.get(url, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  /**
   * This function is used to call the put API, it takes two parameters
   * @param endpoint 
   * @param data 
   */
  put(endpoint, data) {
    const url = getUrl(endpoint);
    return this.http.put(url, data, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  /**
   * This function is used to call the delete API, it takes a single parameter
   * @param endpoint 
   */
  delete(endpoint) {
    const url = getUrl(endpoint);
    return this.http.delete(url, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  uploadFiles(endpoint, formData) {
    const url = getUrl(endpoint);
    return this.http.post(url, formData);
  }

/**
 * This function is used to read the access token from local storage
 */
  getAccessToken(){
    return JSON.parse(localStorage.getItem("loginData")).access_token
  }

  get_landing_page(endpoint) {
    const url = getUrl(endpoint);
    return this.http.get(url, { headers: this.header })
  }

  post_landing_page(endpoint, data) {
    const url = getUrl(endpoint);
    return this.http.post(url, data, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  /**
   * This function is used to handle the backend error if any
   */
  handleError = (errorResponse: HttpErrorResponse) => {
    this.loader.hide('progress');
    if(errorResponse.status === 401) {
      // this.toastr.warning('Session expired, please login again', '', {
      //   progressBar: true, timeOut: 3000
      // });
      this.auth0.logout();
      // this.auth0.renewTokens();
      // return throwError(errorResponse.error.error)
    }else if(errorResponse.status === 403) {
      this.router.navigateByUrl('unauthorize');
      return throwError(errorResponse.error.error);
    }else if(errorResponse.status === 400 || errorResponse.status === 500) {
      return throwError(errorResponse.error.message || errorResponse.error.error || errorResponse.error || "Something went wrong");
    }else if(errorResponse.status === 404){
      console.log("server side error", errorResponse.error)
      return throwError(errorResponse.error.message || "Server side error");
    }else if(errorResponse.error instanceof ErrorEvent){
      console.log("client side error", errorResponse.error.message)
      return throwError(errorResponse.error.message || "Client side error");
    }else{
      return throwError("Something went wrong");
    }
  }
}
/**
 * This function is used to generate the API url
 * @param endpoint 
 */
function getUrl(endpoint){
  let type = endpoint.split('?')[0];
  type = type.split('/')[0];
  return environment.baseUrl[type] + endpoint;
}